export type FilterBarPlacement = "bottom" | "hide" | "top";

const DEFAULT_FILTER_BAR_PLACEMENT: FilterBarPlacement = "top";

const isFilterBarPlacement = (value: unknown): value is FilterBarPlacement =>
	value === "top" || value === "bottom" || value === "hide";

export const encodeFilterBarPlacement = (placement: FilterBarPlacement): string => btoa(JSON.stringify({ placement }));

const decodeFilterBarPlacement = (base64Settings?: string | null): FilterBarPlacement => {
	if (!base64Settings) return DEFAULT_FILTER_BAR_PLACEMENT;
	try {
		const parsed = JSON.parse(atob(base64Settings)) as { placement?: unknown };
		return isFilterBarPlacement(parsed.placement) ? parsed.placement : DEFAULT_FILTER_BAR_PLACEMENT;
	} catch {
		return DEFAULT_FILTER_BAR_PLACEMENT;
	}
};

const PLACEMENT_CYCLE: Record<FilterBarPlacement, FilterBarPlacement> = {
	bottom: "hide",
	hide: "top",
	top: "bottom"
};

export const nextFilterBarPlacement = (current: FilterBarPlacement): FilterBarPlacement => PLACEMENT_CYCLE[current];

export const shouldShowFilterIndicatorBadge = (placement: FilterBarPlacement, activeFilterCount: number): boolean =>
	placement === "hide" && activeFilterCount > 0;

export const shouldShowFilterBar = (
	placement: FilterBarPlacement,
	activeFilterCount: number,
	mruEntryCount: number
): boolean => placement !== "hide" && (activeFilterCount > 0 || mruEntryCount > 0);

export { DEFAULT_FILTER_BAR_PLACEMENT };
export default decodeFilterBarPlacement;
